import i18n from 'i18next';
import translation from './fa-IR.json';
import {initReactI18next} from 'react-i18next';
import backend from 'i18next-http-backend';
import Config from 'react-native-config';
import { isWeb } from '../constants';

i18n
  .use(initReactI18next) 
  .use(backend) 
  .init({
    backend: {
      loadPath: `${isWeb ? process.env.REACT_APP_API_BASE_URL : Config.REACT_APP_API_BASE_URL}/locale/fa.json`
    },
    lng: 'fa', 
    fallbackLng: 'fa',
    react: {
      useSuspense: true, 
      wait: true
    },
    interpolation: {
      escapeValue: false 
    }
  });

  const mergeLocalTranslations = () => {
    i18n.addResourceBundle('fa', 'translation', translation, true, true);
  };

  i18n.on('loaded', mergeLocalTranslations);
  i18n.on('failedLoading', mergeLocalTranslations);
  

export default i18n;
